import {
  getManagerProfilesRetrieveQueryOptions,
  getStafferTosAcceptanceRetrieveQueryOptions,
} from "@sidegigllc/api/client";
import type { QueryClient } from "@tanstack/react-query";
import { createRoute, redirect } from "@tanstack/react-router";
import { activeLocationsQueryOptions, organizationsQueryOptions } from "api/queries/locations";
import { loadAuthUser } from "domains/auth/access/authUser";
import { AuthProvider } from "domains/auth/providers/Root";
import { AUTH_STALE_TIME } from "domains/auth/providers/Root/helpers";
import { forwardParams } from "domains/auth/queries/helpers";
import type { Auth } from "../context";
import { rootRoute } from "./root";

const resolveAuth = async (queryClient: QueryClient): Promise<Auth | null> => {
  const user = await loadAuthUser(queryClient);
  if (!user) return null;

  const managerProfile = await queryClient
    .query({
      ...getManagerProfilesRetrieveQueryOptions("me", { query: { staleTime: AUTH_STALE_TIME } }),
      staleTime: "static",
    })
    .catch(() => {});

  void queryClient
    .query(
      getStafferTosAcceptanceRetrieveQueryOptions("me", {
        query: { staleTime: Number.POSITIVE_INFINITY, retry: false },
      }),
    )
    .catch(() => {});
  void queryClient.query(activeLocationsQueryOptions()).catch(() => {});
  void queryClient.query(organizationsQueryOptions()).catch(() => {});

  return { user, managerProfile: managerProfile ?? undefined };
};

export const authedRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: "authed",
  beforeLoad: async ({ context, location }) => {
    const auth = await resolveAuth(context.queryClient);
    if (!auth) {
      throw redirect({ href: forwardParams(`/auth?returnTo=${encodeURIComponent(location.href)}`) });
    }
    return { auth };
  },
  component: AuthProvider,
});
